import React, { useMemo } from "react";
import BattleSimulationCommanderProfiles from "./BattleSimulationCommanderProfiles";
import {
  getMyCommanderProfile,
  getMyCommanderLinkCandidate,
  updateMyCommanderProfile,
  linkMyCommanderByCommanderId,
} from "./battle-simulation/profileApi";
import "./css/MyCommander.css";

const MyCommander = () => {
  const profileApiOverrides = useMemo(() => ({
    listProfiles: async () => {
      const profile = await getMyCommanderProfile();
      return profile ? [profile] : [];
    },
    createProfile: async () => getMyCommanderProfile(),
    updateProfile: async (_profileId, payload) => updateMyCommanderProfile(payload),
    deleteProfile: async () => false,
  }), []);

  return (
    <BattleSimulationCommanderProfiles
      singleProfileMode
      pageTitle=""
      showBackToSimulation={false}
      profileApiOverrides={profileApiOverrides}
      hideProfileName
      commanderLinkMode="gameId"
      getCommanderLinkCandidateApi={getMyCommanderLinkCandidate}
      linkCommanderByGameIdApi={linkMyCommanderByCommanderId}
    />
  );
};

export default MyCommander;
